/* ==========================================================================
   KINOVA — axborot sahifalari (FAQ / aloqa), Bosqich 13.

   ⚠️ BU SKRIPT MAJBURIY EMAS: FAQ akkordeoni nativ `<details>` elementida
      qurilgan — JS o'chirilgan bo'lsa ham ochiladi/yopiladi. Bu yerdagi
      kod faqat QULAYLIK qo'shadi:
        1. Bir guruhda bitta savol ochilsa, qolganlari yopiladi.
        2. Aloqa formasida qolgan belgilar soni ko'rsatiladi.
   ========================================================================== */
(function () {
    'use strict';

    /* ── FAQ: bir vaqtda bitta savol ochiq ──────────────────────────── */
    document.querySelectorAll('.js-faq-list').forEach(function (list) {
        var items = list.querySelectorAll('details.faq-item');

        items.forEach(function (item) {
            item.addEventListener('toggle', function () {
                if (!item.open) return;

                items.forEach(function (other) {
                    if (other !== item) other.open = false;
                });
            });
        });
    });

    /* ── Aloqa formasi: qolgan belgilar hisoblagichi ─────────────────── */
    var textarea = document.getElementById('contact-message');
    var counter = document.querySelector('.js-char-left');

    if (textarea && counter) {
        var max = parseInt(textarea.getAttribute('maxlength'), 10) || 5000;

        var update = function () {
            counter.textContent = String(Math.max(0, max - textarea.value.length));
        };

        textarea.addEventListener('input', update);
        update();
    }
})();
